document.addEventListener("DOMContentLoaded", function() {
  const circles = document.querySelectorAll(".number_speed");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          circles.forEach((circle, index) => {
            setTimeout(() => {
              circle.classList.add("active");
            }, index * 1500); // 1.5s delay between each circle
          });
          observer.disconnect(); // run only once
        }
      });
    },
    { threshold: 0.4 }
  );

  const section = document.querySelector(".high_performance_section");
  if (section) observer.observe(section);

  // accordion script starts
  const accordions = document.querySelectorAll(".accordion details");
  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function () {
      if (this.open) {
        accordions.forEach((other) => {
          if (other !== this && other.open) {
            other.removeAttribute("open");
          }
        });
      }
    });
  });
  // ends
});




document.addEventListener("DOMContentLoaded", function() {
  const loader = document.querySelector(".loader_icon");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loader.classList.add("active");
          observer.disconnect();
        }
      });
    },
    { threshold: 0.4 }
  );

  if (loader) observer.observe(loader);
});



document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".zed-reason-item");
  let index = 0;

  function activateItem() {
    items.forEach((item, i) => {
      item.classList.toggle("active", i === index);
    });
    index = (index + 1) % items.length;
  }

  activateItem();
  setInterval(activateItem, 4000); // rotates every 4 seconds
});

// product page js starts
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.description-toggle').forEach(function(btn) {
    btn.addEventListener('click', function () {
      const wrapper = btn.closest('.product__description');
      if (!wrapper) return;

      const preview = wrapper.querySelector('.desc-preview');
      const full = wrapper.querySelector('.desc-full');
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (!expanded) {
        // show full HTML, hide preview
        if (full) {
          full.style.display = '';
          full.setAttribute('aria-hidden', 'false');
        }
        if (preview) {
          preview.style.display = 'none';
          preview.setAttribute('aria-hidden', 'true');
        }
        btn.textContent = 'Read Less';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        // collapse to preview
        if (full) {
          full.style.display = 'none';
          full.setAttribute('aria-hidden', 'true');
        }
        if (preview) {
          preview.style.display = '';
          preview.setAttribute('aria-hidden', 'false');
        }
        btn.textContent = 'Read More';
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {

  const popup = document.querySelector('#PopupModal-popup_BNyJwe');

  // OPEN popup
  document.addEventListener('click', function (e) {
    if (e.target.closest('.size_guide_btn')) {
      popup.classList.add('active');
      document.body.classList.add("overflow_hidden")
    }
  });

  // CLOSE popup (supports both classes)
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.close-popup') || 
      e.target.closest('#ModalClose-popup_BNyJwe')
    ) {
      popup.classList.remove('active');
      document.body.classList.remove("overflow_hidden")
    }
  });

  // Close if clicking outside popup content
  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      popup.classList.remove('active');
      document.body.classList.remove("overflow_hidden")
    }
  });

});

// product page tab buttons
document.addEventListener("DOMContentLoaded", function () {
  // Get tab buttons
  const tabs = document.querySelectorAll(".half");

  // Get tab content sections
  const womenContent = document.querySelector(".women");
  const menContent = document.querySelector(".men");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove("active"));

      // Add active class to clicked tab
      this.classList.add("active");

      // Show/Hide content based on data-id
      const id = this.getAttribute("data-id");

      if (id === "women-tab") {
        womenContent.style.display = "block";
        menContent.style.display = "none";
      } else if (id === "men-tab") {
        menContent.style.display = "block";
        womenContent.style.display = "none";
      }
    });
  });

  // Set default state (Women active)
  womenContent.style.display = "block";
  menContent.style.display = "none";
});


// ends